import { render, staticRenderFns } from "./HorizonApp.vue?vue&type=template&id=99ac8c66&"
import script from "./HorizonApp.vue?vue&type=script&lang=js&"
export * from "./HorizonApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports